import React, { useEffect, useState } from "react";
import Layout from "../components/layout/Layout";
import { useNavigate } from "react-router-dom";
import { ButtonM, ButtonS, ButtonXS } from "../styles/Common";
import styled from "styled-components";
import MainSlide from "../components/main/MainSlide";
import AffiliateList from "../components/main/AffiliateList";
import SingUpBanner from "../components/main/SingUpBanner";
import PointChangeList from "../components/main/PointChangeList";
import { useDispatch, useSelector } from "react-redux";
import { mainActions } from "../store/slices/mainSlice";
import PointBanner from "../components/pointChange/PointBanner";
import TopPointBanner from "../components/main/TopPointBanner";
import { getToken, returnLoginStatus } from "../components/hooks/authFunc";
import { userActions } from "../store/slices/userSlice";
import CompanyInfo from "../components/main/CompanyInfo";

const MainPage = () => {
  const [input, setInput] = useState("");
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const bannerData = useSelector((state) => state.main.bannerList);
  const isLogin = returnLoginStatus();
  useEffect(() => {
    getData();
    dispatch(mainActions.showStartPage());
  }, []);
  const getData = () => {
    const params = {};
    dispatch(mainActions.fetchBannerList({ params }));
  };
  return (
    <Layout>
      {isLogin && <TopPointBanner />}
      <MainSlide data={bannerData} />
      <AffiliateList />
      <SingUpBanner isLogin={isLogin} />
      <PointChangeList />
      <CompanyInfo />
    </Layout>
  );
};

export default MainPage;
